// 用于 web 环境（PC 端 web）的 SDK
import { StatisticsWeb } from '@yuanfudao/metis-statistics-web';
import { useEffect } from 'react';
// 需要替换成你 SDK 的 package.json 的路径
import pkgJson from '../../package.json';
export var statisticsInstances = new StatisticsWeb({
  sdkName: pkgJson.name,
  sdkVersion: pkgJson.version,
  // 当 env 为 'production' 或 'online' 时，表示线上环境，其他值为测试环境
  env: process.env.REACT_APP_ENV || 'development',
  frogConfig: {
    immediate: false
  }
});
// 创建自定义 hook，方便在有需要的地方上报
export function useStatistics(name) {
  useEffect(function () {
    if (name) {
      statisticsInstances.add(name);
    }
  }, [name]);
}